import * as Constants from "../constants";
import * as InitialStates from "../constants/initialStates";

export default function userReducer(state = InitialStates.getInitialUserState(), action) {
  switch (action?.type) {
    case Constants.GET_CURRENT_WITHOUT_RELATIONSHIPS_USER: {
      return {
        ...state,
        loadingUser: true,
        errorFetchingUser: false,
      };
    }
    case Constants.GET_CURRENT_USER_JWT: {
      return {
        ...state,
        loadingJWT: true,
        errorFetchingJWT: false,
      };
    }
    case Constants.GET_CURRENT_WITHOUT_RELATIONSHIPS_USER_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        loadingUser: false,
        errorFetchingUser: false,
        user: {
          id: data?.id?.toString(),
          permalink: data?.permalink,
          avatar: `${window.ENV.CDN_DOMESTIKA_URL}/${data?.avatar?.url}`,
        },
      };
    }
    case Constants.GET_CURRENT_USER_JWT_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        loadingJWT: false,
        errorFetchingJWT: false,
        jwt: data?.token,
      };
    }
    case Constants.GET_CURRENT_WITHOUT_RELATIONSHIPS_USER_ERROR: {
      return {
        ...state,
        loadingUser: false,
        errorFetchingUser: true,
      };
    }
    case Constants.GET_CURRENT_USER_JWT_ERROR: {
      return {
        ...state,
        loadingJWT: false,
        errorFetchingJWT: true,
      };
    }
    default:
      return state;
  }
}
